import moment from "moment-timezone";
import { useTranslation } from "react-i18next";

function LicenseStatusColumn({ expiresAt }) {
  const { t } = useTranslation();
  const expired = !!expiresAt && moment.utc(expiresAt).isBefore(moment.utc());

  return <span className={`bold ${expired ? "text-danger" : "text-success"}`}>{expired ? t("common.labels.expired") : t("common.labels.active")}</span>;
}

export default LicenseStatusColumn;
